import {
  FaEnvelopeOpenText,
  FaLocationArrow,
  FaMailBulk,
  FaPhoneAlt,
} from "@onemind-services-llc/react-icons-ng/fa";

export const CONTACT_FORM_CONSTANTS = {
  UNITED_STATES: "United States",
};

export const CONTACT_LIST = [
  {
    icon: FaEnvelopeOpenText,
    label: "sales@onemindservices.com",
    path: "mailto:sales@onemindservices.com",
  },
  {
    icon: FaMailBulk,
    label: "support@onemindservices.com",
    path: "mailto:support@onemindservices.com",
  },
  { icon: FaPhoneAlt, label: "1-408-540-6771", path: "tel:1-408-540-6771" },
  {
    isExternal: true,
    icon: FaLocationArrow,
    label: "11501 Dublin Bvld, Suite#200 Dublin CA 94568",
    path: "https://maps.google.com?q=11501 Dublin Bvld, Suite#200 Dublin CA 94568",
  },
];
